export default function getDateSeriesLimits(dateSeries) {
  const firstDate = dateSeries.dates.reduce((a, b) =>
    a.start < b.start ? a : b
  );
  const lastDate = dateSeries.dates.reduce((a, b) =>
    a.start > b.start ? a : b
  );
  return {
    start: firstDate.start,
    end: lastDate.end
  };
}
